<template>
  <div>
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->
    <v-card>
      <v-card-title style="padding:0px">
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <v-layout row>
      <v-flex sm12>
        <!-- LISTE DES CHANTIERS-->
        <listeProjet :listeProjets="projets"></listeProjet>
        <!-- LISTE DES CHANTIERS-->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import listeProjet from "@/components/boardProjet/liste_projet";
import Loading from "@/components/Loading";

export default {
  components: { listeProjet, Loading },
  name: "IndexProjet",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [
        { path: "/boardProjet", text: "DashBoard Projet", disabled: false }
      ],

      projets: []
    };
  },

  methods: {
    loadProjet() {
      this.loading = true;
      let url = this.domaine + "projet/" + this.user.id + "/chefProjet/index";
      this.$http.get(url).then(
        response => {
          this.projets = response.body.projet;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des projets");
        }
      );
    }
  },

  mounted() {
    this.loadProjet();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/boardProjet/indexProjet.vue